import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter } from './tabular-type.dataset.adapter';
import { ODataResourceDataset } from 'app/model/dataset/odata-resource.dataset';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ODataResourceDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            folder: '*',
            annotations: '*',
            structure: '*',
            linkedServiceName: '*',
            parameters: '*',
            type: '*',
            typeProperties: {
                path: '*'
            }
        }
    }
})
export class ODataResourceDatasetAdapter extends TabularTypeDatasetAdapter<ODataResourceDataset, Model.DatasetResource> {
    protected async _toResource(dataset: ODataResourceDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(ODataResourceDataset).name, 'path');
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: ODataResourceDataset): Promise<ODataResourceDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset,  ODataResourceDataset.MODEL, 'path');
    }
}
